import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MultiSelectModule } from 'primeng/multiselect';
import { ArticleCardLoadingComponent } from '../shared/components/article-card-loading/article-card-loading.component';
import { ArticleCardComponent } from '../shared/components/article-card/article-card.component';
import { LazyLoadDirective } from '../shared/directives/lazy-load.directive';
import { ArticlesComponent } from './articles.component';
import { mergeMap, Observable } from 'rxjs';
import { Article } from '../admin/shared/public-api';

@Component({
  selector: 'app-articles',
  templateUrl: './articles.component.html',
  styleUrls: ['./articles.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MultiSelectModule,
    ArticleCardComponent,
    ArticleCardLoadingComponent,
    LazyLoadDirective,
  ],
})
export class BelgiumArticlesComponent extends ArticlesComponent {
  constructor(
    private route: ActivatedRoute,
    titleService: Title,
  ) {
    super(route, titleService);
  }

  override getArticlesObservable(): Observable<Article[]> {
    return this.destinationService
      .getDestinationByCountry('Belgique')
      .pipe(
        mergeMap((d) =>
          this.articleService.getArticlesWithFilter(
            this.route.snapshot.data['category'],
            d.id,
            this.articles.length,
            this.TAKE,
          ),
        ),
      );
  }
}
